export const featuredArticles = [
  {
    slug: "latest-access-2026",
    title: "禁漫天堂2026年最新访问入口汇总（持续更新）",
    excerpt: "本文汇总禁漫天堂所有当前可用的访问入口与镜像站点，确保用户能够稳定、快速地访问平台全部功能。包含PC端、移动端与APP端访问方式。",
    date: "2026-08-08",
    category: "使用教程",
    imageSeq: "feat-01",
    isNew: true,
  },
  {
    slug: "register-login-guide",
    title: "禁漫天堂新用户注册与登录完整教程",
    excerpt: "手把手教你完成禁漫天堂的新用户注册流程，包括邮箱注册、手机号绑定、第三方账号登录等多种方式，以及常见登录问题解决方案。",
    date: "2026-08-06",
    category: "使用教程",
    imageSeq: "feat-02",
    isNew: true,
  },
  {
    slug: "content-category-overview",
    title: "禁漫天堂内容分类完整导览：找到你喜欢的漫画",
    excerpt: "详细介绍禁漫天堂的内容分类体系，帮助你快速定位感兴趣的热血、恋爱、奇幻、搞笑、悬疑、科幻等各类型漫画作品。",
    date: "2026-08-04",
    category: "内容导览",
    imageSeq: "feat-03",
    isNew: false,
  },
  {
    slug: "mirror-site-guide",
    title: "禁漫天堂镜像站使用指南与注意事项",
    excerpt: "全面解析禁漫天堂镜像站的使用方法、访问技巧以及安全注意事项，确保你的阅读体验顺畅无阻且数据安全。",
    date: "2026-08-02",
    category: "使用教程",
    imageSeq: "feat-04",
    isNew: false,
  },
  {
    slug: "mobile-app-guide",
    title: "禁漫天堂移动端APP下载安装全攻略",
    excerpt: "详细介绍禁漫天堂移动端APP的下载渠道、安装步骤、功能亮点以及常见问题处理，让你随时随地畅享漫画阅读。",
    date: "2026-07-30",
    category: "使用教程",
    imageSeq: "feat-05",
    isNew: false,
  },
  {
    slug: "reading-experience-optimize",
    title: "提升禁漫天堂阅读体验的10个实用技巧",
    excerpt: "分享10个提升漫画阅读体验的实用技巧，包括阅读模式选择、书签管理、下载设置、夜间模式等功能的深度使用。",
    date: "2026-07-28",
    category: "使用教程",
    imageSeq: "feat-06",
    isNew: false,
  },
];

export const articleDetails: Record<string, {
  title: string;
  date: string;
  category: string;
  content: Array<{type: "p" | "h2" | "h3" | "list" | "image"; text?: string; items?: string[]; imageUrl?: string; caption?: string}>;
}> = {
  "latest-access-2026": {
    title: "禁漫天堂2026年最新访问入口汇总（持续更新）",
    date: "2026-08-08",
    category: "使用教程",
    content: [
      { type: "p", text: "禁漫天堂作为广受用户关注的漫画阅读平台，其访问入口可能会因网络环境变化而调整。为了帮助用户始终能够顺利访问禁漫天堂，我们特别整理并持续更新本文，汇总所有当前可用的访问方式。" },
      { type: "h2", text: "一、官方主站入口" },
      { type: "p", text: "禁漫天堂官方主站是访问平台最直接、最稳定的方式。官方主站经过严格的安全检测与性能优化，能够为用户提供最佳的漫画阅读体验。我们建议用户优先通过官方主站进行访问，以确保账号安全与数据完整。" },
      { type: "h3", text: "PC端访问" },
      { type: "p", text: "在电脑浏览器中直接输入禁漫天堂官方域名即可访问。推荐使用Chrome、Edge、Firefox等主流浏览器的最新版本，以获得最佳的页面渲染效果和阅读体验。如遇到加载缓慢的情况，可尝试清除浏览器缓存后重新访问。" },
      { type: "h3", text: "移动端网页访问" },
      { type: "p", text: "禁漫天堂移动端网页版针对手机屏幕进行了专门的适配优化，在手机浏览器中输入官方域名即可自动跳转至移动版界面。移动端网页版支持手势操作翻页、双击放大等便捷功能，让手机阅读漫画同样舒适流畅。" },
      { type: "image", imageUrl: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20illustration%20of%20website%20access%20portal%20interface%2C%20desktop%20browser%20window%2C%20soft%20coral%20cream%20color%20palette%2C%20clean%20simple%20composition%2C%20modern%20digital%20UI%20style&width=1200&height=600&seq=access-01&orientation=landscape", caption: "禁漫天堂官方主站PC端访问界面示意" },
      { type: "h2", text: "二、镜像站点列表" },
      { type: "p", text: "当官方主站因某些原因暂时无法访问时，用户可以通过镜像站点继续使用禁漫天堂的服务。镜像站点与主站数据同步，功能完全一致，提供相同的漫画资源与阅读体验。" },
      { type: "list", items: ["镜像站A：适用于中国大陆地区用户，访问速度快", "镜像站B：适用于海外用户，国际线路优化", "镜像站C：备用镜像，高峰期分流使用", "镜像站D：移动端专用镜像，流量消耗更低"] },
      { type: "h2", text: "三、APP客户端访问" },
      { type: "p", text: "禁漫天堂提供了专门的移动端APP，支持Android和iOS双平台。APP相比网页版拥有更多独家功能，如离线下载、推送通知、个性化推荐等，是重度漫画爱好者的最佳选择。" },
      { type: "list", items: ["Android版：通过官方应用商店或官网下载APK安装包", "iOS版：通过App Store搜索下载（需切换至对应区域账号）", "APP特色功能：离线缓存、夜间模式、自动翻页、弹幕评论"] },
      { type: "image", imageUrl: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20illustration%20of%20mobile%20app%20interface%20for%20comic%20reading%2C%20smartphone%20mockup%2C%20soft%20coral%20cream%20color%20palette%2C%20clean%20simple%20composition%2C%20modern%20digital%20UI%20style&width=1200&height=600&seq=access-02&orientation=landscape", caption: "禁漫天堂移动端APP界面展示" },
      { type: "h2", text: "四、访问注意事项" },
      { type: "p", text: "为确保您能够安全、稳定地使用禁漫天堂的全部功能，请注意以下几点：" },
      { type: "list", items: ["请认准官方渠道发布的访问入口，谨防仿冒网站", "建议收藏本文页面，我们将持续更新最新可用入口", "如所有入口均无法访问，请检查本地网络设置或更换DNS", "遇到访问问题时，可通过官方社交媒体账号获取最新入口信息", "推荐使用HTTPS加密连接访问，保护个人隐私与账号安全"] },
      { type: "p", text: "我们会持续监控各入口的访问状态，并在本文中及时更新。如果您发现某个入口无法正常使用，欢迎通过官方渠道向我们反馈，我们将尽快处理。" },
    ],
  },
  "register-login-guide": {
    title: "禁漫天堂新用户注册与登录完整教程",
    date: "2026-08-06",
    category: "使用教程",
    content: [
      { type: "p", text: "欢迎加入禁漫天堂！本教程将详细引导你完成从注册到登录的全过程，涵盖多种注册方式和登录方式，帮助你快速开启漫画阅读之旅。即使你是第一次使用漫画阅读平台，也能轻松上手。" },
      { type: "h2", text: "一、注册前的准备" },
      { type: "p", text: "在开始注册之前，请确保你已准备好以下任意一项：一个有效的电子邮箱地址，或一个可接收短信的手机号码。如果你是海外用户，建议使用电子邮箱注册，以避免国际短信延迟的问题。" },
      { type: "h2", text: "二、邮箱注册步骤" },
      { type: "p", text: "邮箱注册是最常用的注册方式，流程简单且安全可靠。" },
      { type: "list", items: ["第一步：打开禁漫天堂官网，点击右上角的「注册」按钮", "第二步：在注册页面选择「邮箱注册」选项", "第三步：输入你的电子邮箱地址，点击「获取验证码」", "第四步：登录你的邮箱，查收来自禁漫天堂的验证邮件（如未收到，请检查垃圾邮件箱）", "第五步：在注册页面输入验证码，设置登录密码（建议使用字母+数字+符号的组合）", "第六步：设置你的昵称和头像，阅读并同意用户协议后点击「完成注册」"] },
      { type: "h2", text: "三、手机号注册" },
      { type: "p", text: "如果你更习惯使用手机号注册，操作同样简单：" },
      { type: "list", items: ["第一步：在注册页面选择「手机号注册」选项", "第二步：选择你的国家/地区代码，输入手机号码", "第三步：点击「获取短信验证码」，输入收到的6位验证码", "第四步：设置密码和昵称，完成注册"] },
      { type: "image", imageUrl: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20illustration%20of%20user%20registration%20form%20interface%2C%20signup%20page%20design%2C%20soft%20coral%20cream%20color%20palette%2C%20clean%20simple%20composition%2C%20modern%20digital%20UI%20style&width=1200&height=600&seq=register-01&orientation=landscape", caption: "禁漫天堂注册页面操作流程示意" },
      { type: "h2", text: "四、第三方账号快捷登录" },
      { type: "p", text: "禁漫天堂支持多种第三方账号快捷登录，省去记忆密码的烦恼：" },
      { type: "list", items: ["微信扫码登录：点击微信图标，使用微信扫描二维码即可登录", "QQ账号登录：点击QQ图标，授权后即可登录", "微博账号登录：点击微博图标，授权后即可登录", "Apple ID登录（iOS用户）：点击Apple图标，使用面容ID或触控ID快速登录"] },
      { type: "h2", text: "五、常见登录问题" },
      { type: "p", text: "以下是一些用户经常遇到的登录问题及解决方法：" },
      { type: "list", items: ["忘记密码：点击登录页面的「忘记密码」，通过注册邮箱或手机号重置密码", "验证码收不到：检查邮箱垃圾箱或手机信号，等待60秒后可重新发送", "账号被锁定：连续输入错误密码5次后账号将临时锁定30分钟，请耐心等待后重试", "第三方登录失败：检查第三方应用的授权设置，确保已授权禁漫天堂的访问权限", "设备更换：在新设备登录可能需要额外验证，请确保绑定的邮箱或手机号可用"] },
      { type: "p", text: "至此，你已经完成了禁漫天堂的注册与登录流程。现在就可以开始探索丰富的漫画资源了！如果在使用过程中遇到任何问题，欢迎随时查阅我们的帮助中心或联系客服。" },
    ],
  },
  "content-category-overview": {
    title: "禁漫天堂内容分类完整导览：找到你喜欢的漫画",
    date: "2026-08-04",
    category: "内容导览",
    content: [
      { type: "p", text: "禁漫天堂拥有海量的漫画资源库，涵盖各种题材和风格。为了让用户能够快速找到自己喜欢的漫画类型，我们建立了完善的内容分类体系。本文将对所有分类进行详细介绍，帮助你精准定位心仪的作品。" },
      { type: "h2", text: "一、分类体系概述" },
      { type: "p", text: "禁漫天堂的分类体系从四个维度进行组织：题材类型、受众定位、连载状态、热门排行。每个维度下又细分为多个子分类，用户可以通过组合筛选快速找到目标作品。" },
      { type: "image", imageUrl: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20illustration%20of%20content%20category%20navigation%20interface%2C%20grid%20layout%20design%2C%20soft%20coral%20cream%20color%20palette%2C%20clean%20simple%20composition%2C%20modern%20digital%20UI%20style&width=1200&height=600&seq=category-01&orientation=landscape", caption: "禁漫天堂内容分类导航界面" },
      { type: "h2", text: "二、题材类型详解" },
      { type: "p", text: "题材类型是用户最常用的分类方式，主要包括以下类别：" },
      { type: "list", items: ["热血动作：战斗、冒险、竞技类漫画，以激烈的冲突和角色成长为核心", "恋爱言情：校园恋爱、都市情感、纯爱治愈类漫画，聚焦感情描写", "奇幻冒险：异世界、魔法、修仙类漫画，构建宏大的想象世界", "搞笑日常：轻松幽默的日常喜剧，适合放松心情", "悬疑推理：烧脑解谜、犯罪悬疑类漫画，情节紧凑引人入胜", "科幻未来：未来世界、机甲、赛博朋克、太空探索类漫画", "恐怖惊悚：灵异、恐怖、生存类漫画，带来肾上腺素飙升的阅读体验", "历史古风：古装、历史改编、武侠江湖类漫画", "体育竞技：各种体育运动题材的热血竞技漫画"] },
      { type: "h2", text: "三、如何快速找到喜欢的漫画" },
      { type: "p", text: "掌握了分类体系之后，以下是一些实用的小技巧，帮助你更高效地发现好作品：" },
      { type: "list", items: ["使用「多标签筛选」功能：同时选择多个标签（如「热血」+「连载中」+「高评分」），获得更精准的结果", "关注「编辑推荐」栏目：平台编辑每周精选优质作品进行推荐", "查看「读者评分」：高评分的漫画通常质量有保证", "浏览「新作上架」专区：第一时间发现最新上线的漫画作品", "使用「相似作品」推荐：在漫画详情页查看系统推荐的相似作品"] },
      { type: "p", text: "现在你已经全面了解了禁漫天堂的内容分类体系，赶快去探索丰富的漫画世界吧！如果在浏览过程中有任何建议，欢迎通过反馈渠道告诉我们。" },
    ],
  },
  "mirror-site-guide": {
    title: "禁漫天堂镜像站使用指南与注意事项",
    date: "2026-08-02",
    category: "使用教程",
    content: [
      { type: "p", text: "镜像站点是禁漫天堂为用户提供的备用访问方案。当主站因网络波动或其他原因无法正常访问时，镜像站能够确保用户持续获得服务。本文将详细介绍镜像站的使用方法和注意事项。" },
      { type: "h2", text: "一、什么是镜像站" },
      { type: "p", text: "镜像站是禁漫天堂主站的完整复制版本，部署在不同的服务器和网络线路上。镜像站与主站的数据实时同步，用户在镜像站上的所有操作（阅读记录、收藏、书签等）都会同步到主站账号中。" },
      { type: "h2", text: "二、如何选择镜像站" },
      { type: "p", text: "不同的镜像站针对不同地区和网络环境进行了优化，选择合适的镜像站可以获得更快的访问速度。" },
      { type: "list", items: ["中国大陆用户：优先选择针对国内网络优化的镜像站", "港澳台用户：选择亚太地区优化的镜像节点", "海外用户：选择国际线路优化的镜像站", "移动网络用户：选择移动端专用镜像站以减少流量消耗"] },
      { type: "h2", text: "三、安全注意事项" },
      { type: "p", text: "使用镜像站时，请务必注意以下安全事项：" },
      { type: "list", items: ["仅使用官方发布的镜像站列表中的地址，不要通过搜索引擎搜索到的第三方链接访问", "确认镜像站域名与官方公布的一致，警惕仿冒站点", "不要在非官方镜像站输入账号密码等敏感信息", "建议开启浏览器的安全浏览功能", "如发现可疑镜像站，请及时向官方举报"] },
      { type: "h2", text: "四、常见问题" },
      { type: "p", text: "Q：镜像站和主站的数据是否互通？A：是的，镜像站与主站使用同一数据库，所有数据实时同步。Q：在镜像站充值的金币在主站能用吗？A：完全可以，账户余额在所有官方渠道通用。Q：镜像站的安全性如何？A：官方镜像站采用与主站相同的安全等级，数据传输全程加密。" },
    ],
  },
  "mobile-app-guide": {
    title: "禁漫天堂移动端APP下载安装全攻略",
    date: "2026-07-30",
    category: "使用教程",
    content: [
      { type: "p", text: "禁漫天堂移动端APP为用户提供了更加便捷的漫画阅读体验。相比网页版，APP拥有离线下载、个性化推荐、推送通知等专属功能。本文将全面介绍APP的下载安装与使用方法。" },
      { type: "h2", text: "一、Android版下载安装" },
      { type: "p", text: "Android用户可以通过以下方式获取禁漫天堂APP：" },
      { type: "list", items: ["官方应用商店下载：在主流Android应用商店搜索「禁漫天堂」下载", "官网直接下载：访问禁漫天堂官网，在下载页面获取最新版APK安装包", "安装提示：下载APK后需在手机设置中开启「允许安装未知来源应用」选项"] },
      { type: "h2", text: "二、iOS版下载安装" },
      { type: "p", text: "iOS用户获取APP的方式：" },
      { type: "list", items: ["App Store搜索下载：在App Store中搜索「禁漫天堂」下载安装", "TestFlight测试版：关注官方公告获取TestFlight测试邀请链接", "企业签名版：通过官网提供的企业签名链接安装"] },
      { type: "image", imageUrl: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20illustration%20of%20mobile%20app%20features%20showcase%2C%20comic%20reading%20app%20mockup%2C%20soft%20coral%20cream%20color%20palette%2C%20clean%20simple%20composition%2C%20modern%20digital%20UI%20style&width=1200&height=600&seq=app-01&orientation=landscape", caption: "禁漫天堂APP功能界面展示" },
      { type: "h2", text: "三、APP核心功能亮点" },
      { type: "list", items: ["离线下载：将喜欢的漫画下载到本地，无网络也能畅快阅读", "智能推荐：基于阅读历史进行个性化内容推荐", "推送通知：关注的漫画更新时第一时间推送提醒", "阅读模式：多种阅读模式可选，包括竖屏滚动、横屏翻页等", "夜间模式：护眼夜间模式，暗光环境下也能舒适阅读", "书签同步：云端同步阅读进度和书签，多设备无缝切换"] },
      { type: "h2", text: "四、常见安装问题" },
      { type: "p", text: "Q：安装时提示「解析包错误」怎么办？A：请检查下载的APK文件是否完整，尝试重新下载或清理手机存储空间后重试。Q：iOS安装后提示「未受信任的企业级开发者」？A：前往「设置→通用→VPN与设备管理」中信任该企业证书即可。" },
    ],
  },
  "reading-experience-optimize": {
    title: "提升禁漫天堂阅读体验的10个实用技巧",
    date: "2026-07-28",
    category: "使用教程",
    content: [
      { type: "p", text: "想要在禁漫天堂获得最佳的漫画阅读体验？本文总结了10个实用技巧，帮助你充分利用平台的各种功能，让每一次阅读都成为一种享受。" },
      { type: "h2", text: "阅读设置篇" },
      { type: "list", items: ["技巧一：选择合适的阅读模式——竖屏滚动适合手机单手操作，横屏翻页适合平板大屏，可根据设备和习惯自由切换", "技巧二：开启夜间模式——在暗光环境下阅读时，开启夜间模式可减少蓝光刺激，保护视力", "技巧三：调整图片质量——在网络不佳时选择标清模式加快加载速度，WiFi环境下选择高清模式享受最佳画质"] },
      { type: "h2", text: "效率工具篇" },
      { type: "list", items: ["技巧四：善用书签功能——在精彩章节添加书签，方便日后快速回顾", "技巧五：使用自动翻页——设置自动翻页间隔时间，解放双手轻松阅读", "技巧六：批量下载——WiFi环境下提前下载多话漫画，通勤路上不消耗流量"] },
      { type: "h2", text: "进阶技巧篇" },
      { type: "list", items: ["技巧七：创建分类收藏夹——按类型整理收藏的漫画，建立个人漫画图书馆", "技巧八：开启更新提醒——关注喜欢的漫画并开启更新提醒，不错过任何一话", "技巧九：参与社区互动——在评论区与其他读者交流，分享阅读心得与发现", "技巧十：使用跨设备同步——登录同一账号，在手机、平板、电脑间无缝切换阅读进度"] },
      { type: "p", text: "掌握以上技巧后，相信你的禁漫天堂阅读体验将大幅提升。如果你有自己的独门阅读技巧，也欢迎在社区中与大家分享！" },
    ],
  },
};